import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectCurrentSiteId } from '../../../features/site/site.selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ConfigPanelMode } from '../../../enums/config';
import {
  selectConfigDisplaySitesFilters,
  selectConfigLeftPanelMode
} from '../../../features/config/config.selectors';
import {
  selectCurrentOrganization, selectOrganizationTotal
} from '../../../features/organization/organization.selectors';
import {
  setConfigLeftPanelMode,
} from '../../../features/config/config.actions';
import { selectSite } from '../../../features/site/site.actions';
import { SiteService } from '../../../services/site.service';
import {
  setDetectionFilters
} from '../../../features/detection/detection.actions';

@Component({
    selector: 'left-panel',
    templateUrl: './left-panel.component.html',
    styleUrls: ['./left-panel.component.scss'],
    standalone: false
})
export class LeftPanelComponent {

  readonly organization$ = this.store.select(selectCurrentOrganization);
  readonly organizationCount$ = this.store.select(selectOrganizationTotal);
  siteSelected: boolean = false;
  leftSideMode: ConfigPanelMode = ConfigPanelMode.MODE_EXPANDED;
  sideModeEnum = ConfigPanelMode;
  displaySitesFilters: boolean = false;

  constructor(private store: Store,
              private siteService: SiteService) {
    this.handleSiteSelected();
    this.handleConfig();
  }

  private handleSiteSelected(): void {
    this.store.select(selectCurrentSiteId)
      .pipe(takeUntilDestroyed())
      .subscribe(id => {
        this.siteSelected = !!id;
      })
  }

  private handleConfig(): void {
    this.store.select(selectConfigLeftPanelMode)
      .pipe(takeUntilDestroyed())
      .subscribe((sideMode: ConfigPanelMode) => {
        this.leftSideMode = sideMode;
      });
    this.store.select(selectConfigDisplaySitesFilters)
      .pipe(takeUntilDestroyed())
      .subscribe((displaySitesFilters: boolean) => {
        this.displaySitesFilters = displaySitesFilters;
      });
  }

  togglePanel(): void {
    const mode = (this.leftSideMode === ConfigPanelMode.MODE_EXPANDED) ? ConfigPanelMode.MODE_COLLAPSED : ConfigPanelMode.MODE_EXPANDED;
    this.store.dispatch(setConfigLeftPanelMode({mode}));
  }

  close(site: any): void {
    this.siteService.flyTo(site);
    this.store.dispatch(selectSite({siteId: undefined}));
    this.store.dispatch(setDetectionFilters({filters: undefined}));
  }
}
